export class CustomFieldModel{
    firstName: string;
    lastName: string;
    employeeId: string;
    role: string;
}